/* globals $, window, moment */
$(function () {
    'use strict';

    /* DATE PICKERS */

    var minimumDate = moment().add(window.env.minimumSearchOffset || 3, 'days').format('YYYY-MM-DD');
    var maximumDate = moment().add(361, 'days').format('YYYY-MM-DD');

    var pickupDateInput = $('#pickup_date');
    var returnDateInput = $('#return_date');

    pickupDateInput.add(returnDateInput).datepicker({
        language: window.env.language,
        autoclose: true,
        format: 'yyyy-mm-dd',
        startDate: minimumDate,
        endDate: maximumDate
    });

    pickupDateInput.on('change', function () {
        var pickupDate = $(this).val();
        var returnDate = returnDateInput.val();

        if (returnDate && pickupDate > returnDate) {
            returnDateInput.val('');
        }

        if (pickupDate.match(/\d{4}-\d{2}-\d{2}/)) {
            returnDateInput.datepicker('setStartDate', pickupDate);
        } else {
            returnDateInput.datepicker('setStartDate', minimumDate);
        }
    });

    /* LOCATION PICKERS */

    var pickupLocationInput = $('#pickup_location');
    var pickupLocationCodeInput = $('#pickup_location_code');
    var returnLocationInput = $('#return_location');
    var returnLocationCodeInput = $('#return_location_code');
    var diffReturnCheckbox = $('#diff_return');
    var focusedLocationInput = null;

    pickupLocationInput.add(returnLocationInput).airportTypeahead({
        source: function (query, process) {
            query = this.$element.val();
            if (query.length < 3) {
                return;
            }
            $.ajax(window.env.locationTypeAheadUrl, {
                method: 'get',
                type: 'json',
                data: {
                    query: query
                }
            }).then(function (data) {
                if (data.success) {
                    process(data.locations);
                }
            });
        },
        minLength: 3
    }).change(function () {
        var current = $(this).typeahead('getActive');
        var codeInput = $('#' + $(this).attr('name') + '_code');
        if (current && current.name === $(this).val()) {
            codeInput.val(current.id);
        }  else {
            codeInput.val('');
        }
        if (this === pickupLocationInput[0] && !diffReturnCheckbox.is(':checked')) {
            returnLocationInput.val($(this).val());
            returnLocationCodeInput.val(codeInput.val());
        }
    }).focus(function () {
        if (focusedLocationInput === this) {
            return;
        }
        focusedLocationInput = this;
        setTimeout(function () {
            if (focusedLocationInput) {
                focusedLocationInput.select();
            }
        }, 1);
    }).blur(function () {
        if (focusedLocationInput === this) {
            focusedLocationInput = null;
        }
    });

    diffReturnCheckbox.on('change', function () {
        console.log('change');
        if ($(this).is(':checked')) {
            returnLocationInput.val('');
            returnLocationCodeInput.val('');
            returnLocationInput.prop('readonly', false);
        } else {
            returnLocationInput.val(pickupLocationInput.val());
            returnLocationCodeInput.val(pickupLocationCodeInput.val());
            returnLocationInput.prop('readonly', true);
        }
    });
});